import { Dispatch, SetStateAction } from 'react';
import { Crop } from '../CropDialog';

export enum UploadStatesEnum {
  UPLOADING = 'uploading',
  DONE = 'done',
  INTERRUPTED = 'interrupted',
  AWAITING = 'awaiting',
}

export enum MediaTypesEnum {
  PMD_IMAGE_TYPE = 'pmd_bone_image',
  BRIGHTCOVE_TYPE = 'brightcove',
  YOUTUBE_TYPE = 'youtube',
  PLURIMEDIA_TYPE = 'plurimedia',
  DAILYMOTION_TYPE = 'dailymotion',
  SLIDESHOW_TYPE = 'pmd_slideshow',
  AFFILIATION_TYPE = 'ceriseaffiliation',
  PODCAST_TYPE = 'prisma-media-player',
}

export const {
  PMD_IMAGE_TYPE,
  BRIGHTCOVE_TYPE,
  YOUTUBE_TYPE,
  PLURIMEDIA_TYPE,
  DAILYMOTION_TYPE,
  SLIDESHOW_TYPE,
} = MediaTypesEnum;

export interface IframelyLink {
  html?: string;
  href?: string;
  media?: {
    width?: number;
    height?: number;
    'aspect-ratio'?: number;
    scrolling?: string;
  };
  rel: string[];
  type: string;
}
export interface IframelyMedia {
  fileName?: string;
  html: string;
  links: Record<string, IframelyLink[]>;
  meta: Record<string, any>;
  rel: string[];
}

export interface FocusPoint {
  x?: number | null | undefined;
  y?: number | null | undefined;
  relativeX?: number | null | undefined;
  relativeY?: number | null | undefined;
}

export interface OneMedia {
  caption?: string | null;
  credit?: string;
  crop?: Crop;
  focusPoint?: FocusPoint;
  format?: string | null;
  href?: string;
  iframely: IframelyMedia;
  key?: string | null;
  originalName?: string;
  rel?: string | null;
  source?: string;
  target?: string | null;
}

export interface OneImage {
  extension: string;
  fileSize: number;
  height: number;
  id: string;
  namespace: string;
  path: string;
  ratio: number;
  sha1: string;
  url: string;
  width: number;
}

export interface UploadProgress {
  host: string;
  name: string;
  size: number;
  received: number;
  state: UploadStatesEnum;
}

export type ImagesToIframely = (files: File[]) => Promise<IframelyMedia[]>;
export type IframelyFn = (url: string) => Promise<IframelyMedia>;

export interface PluginProps {
  addMedia: (media: OneMedia | OneMedia[]) => void;
  setLoading: (loading: boolean) => void;
  setMedias: React.Dispatch<React.SetStateAction<OneMedia[]>>;
  setProgress: Dispatch<SetStateAction<UploadProgress[]>>;
  updateMedia: (newMedia: OneMedia, idx: number) => void;
}

export type PluginConstructor<P> = (
  parameters: P,
) => React.ComponentType<PluginProps>;

export interface ArticleMedia {
  media?: OneMedia;
  mediaForDisplay?: string;
}
